<template>
  <div class="form">
    <div class="form__box">
      <ui-input
        :type="'text'"
        :placeholder="t('fields.fname')"
        :rules="[required]"
        v-model="firstName"
      />
      <ui-input
        :type="'text'"
        :placeholder="t('fields.lname')"
        :rules="[required]"
        v-model="lastName"
      />
    </div>
    <ui-input
      :type="'email'"
      :placeholder="t('fields.email')"
      :rules="[isEmail]"
      v-model="email"
    />
    <ui-input
      :type="'email'"
      :placeholder="t('fields.subject')"
      :rules="[required]"
      v-model="subject"
    />
    <ui-textarea
      :placeholder="t('fields.message')"
      :rules="[required]"
      v-model="message"
    />
    <ui-button
      @click="contact"
      :isDisabled="!isFormValid"
      :isLoading="isLoading"
    >
      {{ t('buttons.send') }}
    </ui-button>
  </div>
</template>

<script setup>
import {isEmail, required} from "@/core/rules/textFieldRules.js";
import UiInput from "@/components/ui/ui-input.vue";
import {computed, ref} from "vue";
import {useI18n} from "vue-i18n";
import UiTextarea from "@/components/ui/ui-textarea.vue";
import UiButton from "@/components/ui/ui-button.vue";
import {Processes} from "@/core/api/processes.js";
import {useAuthStore} from "@/stores/auth.js";
import {ElNotification} from "element-plus";

const {t} = useI18n()

const authStore = useAuthStore()

const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})

const firstName = ref('')
const lastName = ref('')
const email = ref('')
const subject = ref('')
const message = ref('')

const isLoading = ref(false)

const isFormValid = computed(() => {
  return (
    required(firstName.value) === true &&
    required(lastName.value) === true &&
    isEmail(email.value) === true &&
    required(subject.value) === true &&
    required(message.value) === true
  )
})

const contact = async () => {
  const res = await Processes.contact({
    name: firstName.value + ' ' + lastName.value,
    email: email.value,
    subject: subject.value,
    message: message.value
  }, accessToken.value)

  if (res.data.contactUs.received) {
    ElNotification({
      message: t('popup.contactSuccess'),
      type: 'success'
    })
  } else {
    ElNotification({
      message: res.errors[0].message,
      type: 'error'
    })
  }
}
</script>

<style lang="scss" scoped>
.form {
  width: 414px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 25px 35px 54px;
  border: 1px solid $black;
  border-radius: 15px;
  box-shadow: 0 1px 4px rgba($black, .25);

  &__box {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

@media (max-width: 450px) {
  .form {
    width: 90%;
    gap: 15px;

    &__box {
      flex-direction: column;
      gap: 15px;
    }
  }
}
</style>